import React, { useCallback } from 'react';
import { PopupTypes } from '../../core/constants/popupTypes';
import { popupStore } from '../../store/popupStore';

function IconFairnessMobile() {
  const openFairness = useCallback(() => {
    popupStore.open({ name: PopupTypes.Fairness });
  }, []);

  return (
    <div className='keno-fairness-btn' onClick={openFairness}>
      <span className='icon-fairness' />
    </div>
  );
}
export default IconFairnessMobile;
